import React, { useEffect, useState } from 'react';
export function TopAnnouncementBar() {
  const [secondsLeft, setSecondsLeft] = useState(14 * 60 + 53);
  useEffect(() => {
    if (secondsLeft <= 0) return;
    const t = setInterval(() => setSecondsLeft(s => s > 0 ? s - 1 : 0), 1000);
    return () => clearInterval(t);
  }, [secondsLeft]);
  const mm = Math.floor(secondsLeft / 60).toString().padStart(2, '0');
  const ss = (secondsLeft % 60).toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 bg-black border-b border-gold/20" data-id="element-551">
      <div className="container mx-auto px-4 py-2.5 flex items-center justify-center gap-3 md:gap-4 text-center" data-id="element-552">
        <span className="hidden sm:inline-block w-1.5 h-1.5 rounded-full bg-electric animate-pulse" data-id="element-553" />
        <p className="text-xs md:text-sm text-white font-medium" data-id="element-554">
          <span className="text-gold font-extrabold" data-id="element-555">66% OFF</span>
          <span className="hidden sm:inline text-textsecondary" data-id="element-556">
            {' '}
            — solo hasta que el contador llegue a cero
          </span>
          <span className="sm:hidden text-textsecondary" data-id="element-557"> · oferta cierra</span>
        </p>
        <span className="inline-flex items-center font-mono font-bold text-sm md:text-base text-electric bg-electric/10 border border-electric/30 rounded-md px-2 py-0.5 tabular-nums" data-id="element-558">
          {mm}:{ss}
        </span>
      </div>
    </div>;
}